import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { first, switchMap, tap } from 'rxjs/operators';
import { ToastMessageService } from '../../../core/modules/toast-message/toast-message.service';
import { FormsErrorHandlerService } from 'src/app/core/services/forms-error-handler.service';
import { PlatformService } from '../../../core/services/platform.service';
import { UserInfoService } from '../../../core/services/user/user-info.service';
import { TranslationService } from '../../../core/shared/translation/translation.service';

@Component({
    selector: 'app-crypto-address-confirm',
    template: ``,
})
export class CryptoAddressConfirmComponent implements OnInit {
  private _userInfo = inject(UserInfoService);
  private _route = inject(ActivatedRoute);
  private _toastMessage = inject(ToastMessageService);
  private _platform = inject(PlatformService);
  private _formErrors = inject(FormsErrorHandlerService);
  private _translation = inject(TranslationService);


  ngOnInit() {
    this._route.paramMap.pipe(
      first(),
      switchMap(params => {
        const paymentId = +params.get('paymentId');
        const token = params.get('token');
        return this._userInfo.confirmCryptoAddress(paymentId, token);
      }),
      tap((data) => {
        if (!data?.errors) {
          this._toastMessage.success('t.cashout-crypto-address-confirmed')
        } else {
          // For some reason request have always 200 code status, so catch error handled in tap
          this._toastMessage.error(
             (this._formErrors.ssBackendErrorsToArray(data.errors) &&
              this._formErrors.ssBackendErrorsToArray(data.errors)[0] || `${this._translation.translate('t.is-invalid')}`)
          );
        }
      }),
    ).subscribe(() => {
      if (this._platform.isBrowser) {
        setTimeout(() => {
          window.location.href = '/';
        }, 3000);
      }
    });
  }
}
